module.exports = __webpack_public_path__ + "static/media/ils_loan_status.bfe0d24b.svg";